import { render } from "./TeamKpis.vue?vue&type=template&id=41f673ac&scoped=true"
import script from "./TeamKpis.vue?vue&type=script&lang=js"
export * from "./TeamKpis.vue?vue&type=script&lang=js"

import "./TeamKpis.vue?vue&type=style&index=0&id=41f673ac&scoped=true&lang=css"

import exportComponent from "/var/www/compass/production/releases/20251103101657/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41f673ac"]])

export default __exports__